var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#4196c8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.82,
    cy: 52.82,
    r: 1,
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.82,
    cy: 52.82,
    r: 1,
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.82,
    cy: 36.82,
    r: 1,
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.82,
    cy: 68.82,
    r: 1,
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.96,39.47c.28.48.89.64,1.37.37.48-.28.64-.89.37-1.37-.28-.48-.89-.64-1.37-.37-.48.28-.64.89-.37,1.37Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.47,45.69c.48.28,1.09.11,1.37-.37.28-.48.11-1.09-.37-1.37-.48-.28-1.09-.11-1.37.37-.28.48-.11,1.09.37,1.37Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.47,61.69c.48-.28.64-.89.37-1.37-.28-.48-.89-.64-1.37-.37-.48.28-.64.89-.37,1.37.28.48.89.64,1.37.37Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.18,45.69c.48-.28.64-.89.37-1.37-.28-.48-.89-.64-1.37-.37-.48.28-.64.89-.37,1.37.28.48.89.64,1.37.37Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.69,67.18c.28-.48.11-1.09-.37-1.37-.48-.28-1.09-.11-1.37.37-.28.48-.11,1.09.37,1.37.48.28,1.09.11,1.37-.37Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.69,39.47c.28-.48.11-1.09-.37-1.37-.48-.28-1.09-.11-1.37.37-.28.48-.11,1.09.37,1.37.48.28,1.09.11,1.37-.37Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.82,73.45c-11.37,0-20.62-9.25-20.62-20.62s9.25-20.62,20.62-20.62,20.62,9.25,20.62,20.62c0,.35-.28.62-.62.62s-.62-.28-.62-.62c0-10.68-8.69-19.38-19.38-19.38s-19.38,8.69-19.38,19.38,8.69,19.38,19.38,19.38c.34,0,.62.28.62.62s-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.82,55.45c-1.45,0-2.62-1.18-2.62-2.62s1.18-2.62,2.62-2.62,2.62,1.18,2.62,2.62-1.18,2.62-2.62,2.62Zm0-4c-.76,0-1.38.62-1.38,1.38s.62,1.38,1.38,1.38,1.38-.62,1.38-1.38-.62-1.38-1.38-1.38Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.82,51.45c-.34,0-.62-.28-.62-.62v-10c0-.35.28-.62.62-.62s.62.28.62.62v10c0,.35-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.82,53.45h-7c-.34,0-.62-.28-.62-.62s.28-.62.62-.62h7c.34,0,.62.28.62.62s-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.46,85.45h-3.28c-.69,0-1.3-.47-1.47-1.15l-.85-3.39c-.03-.11-.11-.16-.15-.18-.05-.02-.13-.04-.24.02l-2.99,1.8c-.6.36-1.36.26-1.85-.23l-2.32-2.32c-.49-.49-.58-1.25-.23-1.85l1.8-2.99c.06-.1.04-.19.02-.23-.02-.05-.07-.13-.18-.15l-3.38-.85c-.67-.17-1.15-.77-1.15-1.47v-3.28c0-.69.47-1.3,1.15-1.47l3.39-.85c.11-.03.16-.11.18-.15.02-.05.04-.14-.02-.23l-1.8-2.99c-.36-.6-.26-1.36.23-1.85l2.32-2.32c.49-.49,1.25-.58,1.85-.23l2.99,1.8c.1.06.19.04.24.02.04-.02.13-.07.15-.18l.85-3.39c.17-.67.77-1.14,1.47-1.14h3.28c.7,0,1.3.47,1.47,1.15l.85,3.39c.03.11.11.16.15.18.04.02.13.04.24-.02l2.99-1.8c.59-.36,1.35-.26,1.85.23l2.32,2.32c.49.49.58,1.25.23,1.85l-1.8,2.99c-.06.1-.04.19-.02.23.02.05.07.13.18.15l3.39.85h0c.67.17,1.15.77,1.15,1.47v3.28c0,.69-.47,1.3-1.15,1.47l-3.38.85c-.11.03-.16.11-.18.15-.02.05-.04.14.02.24l1.8,2.99c.36.6.26,1.36-.23,1.85l-2.32,2.32c-.49.49-1.25.59-1.85.23l-2.99-1.79c-.1-.06-.19-.04-.24-.02-.04.02-.13.07-.15.18l-.85,3.39c-.17.67-.77,1.14-1.47,1.14Zm-5.85-5.98c.2,0,.39.04.58.12.45.19.77.56.89,1.03l.85,3.39c.03.12.13.2.25.2h3.28c.12,0,.22-.08.25-.2l.85-3.39c.12-.47.44-.84.89-1.03.45-.19.94-.15,1.36.1l2.99,1.8c.1.06.23.05.32-.04l2.32-2.32c.09-.09.1-.22.04-.32l-1.8-2.99c-.25-.42-.29-.91-.1-1.36.19-.45.56-.77,1.03-.89l3.38-.85c.12-.03.2-.13.2-.25v-3.28c0-.12-.08-.22-.2-.25l-3.39-.85c-.47-.12-.84-.44-1.03-.89-.18-.45-.15-.94.1-1.36l1.8-2.99c.06-.1.05-.23-.04-.32l-2.32-2.32c-.08-.08-.22-.1-.32-.04l-2.99,1.8c-.42.25-.91.29-1.36.1-.45-.19-.77-.56-.89-1.03l-.85-3.39c-.03-.12-.13-.2-.25-.2h-3.28c-.12,0-.22.08-.25.2l-.85,3.39c-.12.47-.44.84-.89,1.03-.45.19-.94.15-1.36-.1l-2.99-1.8c-.1-.06-.24-.05-.32.04l-2.32,2.32c-.09.09-.1.22-.04.32l1.8,2.99c.25.41.29.91.1,1.36-.19.45-.56.77-1.03.89l-3.39.85c-.12.03-.2.13-.2.25v3.28c0,.12.08.22.2.25l3.38.85c.47.12.84.44,1.03.89.19.45.15.94-.1,1.36l-1.8,2.99c-.06.1-.05.23.04.32l2.32,2.32c.08.09.21.1.32.04l2.99-1.8c.24-.14.51-.22.78-.22Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.82,76.12c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29Zm0-9.33c-2.23,0-4.04,1.81-4.04,4.04s1.81,4.04,4.04,4.04,4.04-1.81,4.04-4.04-1.81-4.04-4.04-4.04Z",
    fill: "#dedede",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancy);
export default __webpack_public_path__ + "static/media/consultancy.cc8c8d4b97cbb664bc7c354be059bec4.svg";
export { ForwardRef as ReactComponent };